import { getRouter } from "@/router";
import { DEFAULT_QUERY } from "@/global";
import { computed } from "vue";

let router = null;

const initialize = () => {
  router = getRouter();
};

const onClearSearch = () => {
  if (!router.currentRoute.value.query.tSearch) return;

  const updatedQuery = { ...router.currentRoute.value.query };
  delete updatedQuery["tSearch"];

  router.push({
    query: { ...updatedQuery, ...DEFAULT_QUERY }
  });
};

const onEnterSearch = (searchTerm: string = "") => {
  if (!searchTerm) {
    onClearSearch();
    return;
  }

  router.push({
    query: {
      ...router.currentRoute.value.query,
      ...DEFAULT_QUERY,
      tSearch: searchTerm
    }
  });
};

const searchQuery = computed(() => {
  return router && (router.currentRoute.value.query.tSearch as string);
});

const searchLogic = {
  searchQuery,
  initialize,
  onEnterSearch,
  onClearSearch
};

export { searchLogic };
